import React, { useEffect, useState } from "react"
import { CaretLeft, CaretRight, List, X } from "@phosphor-icons/react"
import { Menu, MenuButton, MenuItem, MenuItems, } from "@headlessui/react"
import BasicCard from "@components/productcards/BasicCard"

import UseWindowSize from "@components/helpers/UseWindowSize"

// mock data
import imgShopBestSellers from '@images/Home/shop-best-sellers-mobile.png'
import imgNewArrivals from '@images/Home/shop-new-arrivals-mobile.png'
import { navigate } from "gatsby"
import NoResultsFound from "@components/common/NoResultsFound"
import LinkButton from "@components/common/LinkButton"
import ScreenCover from "@components/common/ScreenCover"

const swimMenu = [
  {label: 'All Swim', url: '/collections/all'},
  {label: 'New Arrivals', url: '/collections/new-arrivals'},
  {label: 'Tops', url: '/collections/tops'},
  {label: 'Bottoms', url: '/collections/bottoms'},
  {label: 'One Piece', url: '/collections/one-piece-swimwear'},
  {label: 'Solids', url: '/collections/solids'},
  {label: 'Textured', url: '/collections/the-textured-collection'},
  {label: 'Tankinis', url: '/collections/tankinis'},
]

const apparelMenu = [
  {label: 'All Beachwear', url: '/collections/beachwear'},
  // {label: 'All Accessories', url: '/collections/accessories'},
  {label: 'Tanks & Tees', url: '/collections/tanks-tees'},
  {label: 'Dresses & Skirts', url: '/collections/dresses-skirts'},
  {label: 'Shorts', url: '/collections/shorts'},
  {label: 'Bags', url: '/collections/bags'},
  // {label: 'Men\'s Collection', url: '/collections/mens-collection'},
  {label: 'Matching Couple Suits', url: '/collections/his-hers'},
]

const collectionMenu = [
  //{label: 'All Collections', url: '/collections/all'},
    {label: 'Butter Yellow', url: '/collections/the-butter-yellow-collection/'},
    {label: 'Wish You Were Here', url: '/collections/the-wish-you-were-here-collection/'},
    {label: 'Red Hot Gloss', url: '/collections/the-red-hot-gloss-collection'},
    {label: 'Palacio Del Sol', url: '/collections/the-palacio-del-sol-collection'},
    {label: 'Agua Fresca', url: '/collections/the-agua-fresca-collection'},
    {label: 'Henna', url: '/collections/the-henna-collection'},
    {label: 'La Playa Vol. 3', url: '/collections/the-la-playa-vol-3-collection'},
    {label: 'La Vie Boheme', url: '/collections/the-la-vie-boheme-collection'},
    //{label: 'City Sweetheart', url: '/collections/the-city-sweetheart-collection'},
  // {label: 'Banana Bunch', url: '/collections/the-banana-bunch-collection'},
  //{label: 'Wild Hearts', url: '/collections/the-wild-hearts-collection'},
  // {label: 'Solids', url: '/collections/solids'},
  // {label: 'Core', url: '/collections/the-core-collection'},
]

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [menuStack, setMenuStack] = useState(['main'])
  const [searchKeyword, setSearchKeyword] = useState('')
  const [searchResults, setSearchResults] = useState([])

  const { width } = UseWindowSize()

  useEffect(() => {
    if(width >= 768) {
      setMenuOpen(false)
      setMenuStack(['main'])
    }
  }, [width])

  useEffect(() => {
    if(menuOpen) 
      document.body.classList.add("!overflow-hidden") // Prevent page scroll
    else
      document.body.classList.remove("!overflow-hidden") // restore page scroll
  }, [menuOpen])

  useEffect(() => {
    return () => {
      document.body.classList.remove("!overflow-hidden")
    }
  }, [])

  // useEffect(() => {
  //   console.log("menustack:",menuStack)
  // }, [menuStack])

  const navigateTo = (menu) => {
    setMenuStack([...menuStack, menu])
  }

  const navigateBack = () => {
    setMenuStack(menuStack.slice(0, -1))
  }

  const handleMenu = (menuClicked) => {
    setMenuOpen(false)
    setMenuStack(['main'])
    switch(menuClicked) {
      case 'NEW': console.log("new"); break;
      default: return 'NEW'
    }
  }

  const handleSearchFieldChange = (e) => {
    setSearchKeyword(e.target.value)
  }

  const currentMenu = menuStack[menuStack.length - 1]

  const menus = {
    main: (
      <>
        <MenuItem>
          <button
            className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
            onClick={() => {
              navigateTo("shop");
            }}
            aria-label="SHOP"
          >
            SHOP
            <CaretRight size={20} weight="light" />
          </button>
        </MenuItem>
		{process.env.GATSBY_STORE !== "PH" ? (
			<>
                <MenuItem>
					<button
						className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
						onClick={() => {
							navigate("/collections/60-sets/");
						}}
						aria-label="$60 SUMMER SETS"
					>
						$60 SUMMER SETS
					</button>
				</MenuItem>

                <MenuItem>
                    <button
                    className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4 text-danger"
                    onClick={() => {
                        navigate("/collections/all");
                    }}
                    >
                    SALE
                    </button>
                </MenuItem>

				<MenuItem>
					<button
						className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
						onClick={() => {
							navigate("/collections/new-arrivals/");
						}}
						aria-label="NEW"
					>
						NEW
					</button>
				</MenuItem>
				<MenuItem>
					<button
						className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
						onClick={() => {
							navigate("/collections/bestsellers");
						}}
						aria-label="BEST SELLERS"
					>
						BEST SELLERS
					</button>
				</MenuItem>
			</>
		) : (
			<>	
				<MenuItem>
                    <button
						className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
						onClick={() => {
						navigate("/collections/all");
						// handleMenu("NEW");
						}}
						aria-label="SUMMER SEND-OFF SALE"
					>
						SUMMER SEND-OFF SALE
					</button>
                </MenuItem>
                <MenuItem>
					<button
						className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
						onClick={() => {
						navigate("/collections/3500-sets");
						// handleMenu("NEW");
						}}
						aria-label="P3500 SUMMER SETS"
					>
						P3500 SUMMER SETS
					</button>
				</MenuItem>
                <MenuItem>
					<button
						className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
						onClick={() => {
							navigate("/collections/the-core-collection");
						}}
						aria-label="CORE COLLECTION"
					>
						CORE COLLECTION
					</button>
				</MenuItem>
                <MenuItem>
					<button
						className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
						onClick={() => {
							navigate("/collections/new-arrivals/");
						}}
						aria-label="NEW"
					>
						NEW
					</button>
				</MenuItem>
				<MenuItem>
					<button
						className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
						onClick={() => {
							navigate("/collections/bestsellers");
						}}
						aria-label="BEST SELLERS"
					>
						BEST SELLERS
					</button>
				</MenuItem>
				
			</>
		)}
		<MenuItem>
			<button
				className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
				onClick={() => {
					navigate("/lookbooks/studio-to-sea");
				}}
				aria-label="LOOKBOOK"
			>
				LOOKBOOK
			</button>
		</MenuItem>
        <MenuItem>
        <LinkButton
            className={`soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4`}
            to={`/blackbough-beach-club`}
            label={'REWARDS'}
            ariaLabel="REWARDS"
        />
        </MenuItem>
        
        {width < 768 && (
          <>
            <MenuItem>
              <button
                className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
                onClick={() => {
                  navigateTo("customerCare");
                }}
                aria-label="CUSTOMER CARE"
              >
                CUSTOMER CARE
                <CaretRight size={20} weight="light" />
              </button>
            </MenuItem>
            <MenuItem>
              <LinkButton
                className={`soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4`}
                to={`/`}
                label={'FAQ'}
                ariaLabel="FAQ"
              />
              {/* <button
                className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
                onClick={() => {
                  handleMenu("NEW");
                }}
              >
                FAQ
              </button> */}
            </MenuItem>
          </>
        )}
      </>
    ),

    shop: (
      <>
        <MenuItem>
          <button className="soft-button w-full gap-x-4" onClick={navigateBack}>
            <CaretLeft size={20} weight="light" aria-label="SHOP" />
            SHOP
          </button>
        </MenuItem>
        <MenuItem>
          <button
            className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
            onClick={() => {
              navigateTo("swim");
            }}
            aria-label="SWIM"
          >
            SWIM
            <CaretRight size={20} weight="light" />
          </button>
        </MenuItem>
        <MenuItem>
          <button
            className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
            onClick={() => {
              navigateTo("apparel");
            }}
            aria-label="APPAREL"
          >
            APPAREL
            <CaretRight size={20} weight="light" />
          </button>
        </MenuItem>
        <MenuItem>
          <LinkButton
            className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
            to={`/collections/mens-collection/`}
            label={"MEN'S"}
            ariaLabel={"MEN'S"}
          />
        </MenuItem>
        <MenuItem>
          <LinkButton
            className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
            to={`/collections/accessories/`}
            label={"ACCESSORIES"}
            ariaLabel={"ACCESSORIES"}
          />
        </MenuItem>
        <MenuItem>
          <button
            className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
            onClick={() => {
              navigateTo("collection");
            }}
            aria-label="COLLECTION"
          >
            COLLECTION
            <CaretRight size={20} weight="light" />
          </button>
        </MenuItem>
      </>
    ),

    swim: (
      <>
        <MenuItem>
          <button className="soft-button w-full gap-x-4" onClick={navigateBack} aria-label="SWIM BACK">
            <CaretLeft size={20} weight="light" />
            SWIM
          </button>
        </MenuItem>
        {swimMenu.map((item, index) => {
          return (
            <MenuItem key={`swim-${item?.label}-${index}`}>
              <LinkButton
                className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
                to={`${item?.url}`}
                label={item?.label}
                ariaLabel={item?.label}
              />
            </MenuItem>
          );
        })}
      </>
    ),

    apparel: (
      <>
        <MenuItem>
          <button className="soft-button w-full gap-x-4" onClick={navigateBack} aria-label="APPAREL BACK">
            <CaretLeft size={20} weight="light" />
            APPAREL
          </button>
        </MenuItem>
        {apparelMenu.map((item, index) => {
          return (
            <MenuItem key={`apparel-${item?.label}-${index}`}>
              <LinkButton
                className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
                to={`${item?.url}`}
                label={item?.label}
                ariaLabel={item?.label}
              />
            </MenuItem>
          );
        })}
      </>
    ),

    collection: (
      <>
        <MenuItem>
          <button className="soft-button w-full gap-x-4" onClick={navigateBack} aria-label="COLLECTION BACK">
            <CaretLeft size={20} weight="light" />
            COLLECTION
          </button>
        </MenuItem>
        {collectionMenu.map((item, index) => {
          return (
            <MenuItem key={`collection-${item?.label}-${index}`}>
              <LinkButton
                className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
                to={`${item?.url}`}
                label={item?.label}
                aria-label={item?.label}
              />
            </MenuItem>
          );
        })}
      </>
    ),

    customerCare: (
      <>
        <MenuItem>
          <button className="soft-button w-full gap-x-4" onClick={navigateBack} aria-label="CUSTOMER CARE BACK">
            <CaretLeft size={20} weight="light" />
            CUSTOMER CARE
          </button>
        </MenuItem>
        <MenuItem>
          <button
            className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
            onClick={() => {
              navigateTo("shipping");
            }}
            aria-label="SHIPPING & ORDERS"
          >
            SHIPPING & ORDERS
            <CaretRight size={20} weight="light" />
          </button>
        </MenuItem>
        <MenuItem>
          <button
            className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
            onClick={() => {
              navigateTo("findYourFit");
            }}
            aria-label="FIND YOUR FIT"
          >
            FIND YOUR FIT
            <CaretRight size={20} weight="light" />
          </button>
        </MenuItem>
        <MenuItem>
          <button
            className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
            onClick={() => {
              navigateTo("returns");
            }}
            aria-label="RETURNS & EXCHANGES"
          >
            RETURNS & EXCHANGES
            <CaretRight size={20} weight="light" />
          </button>
        </MenuItem>
        <MenuItem>
          <button
            className="soft-button w-full justify-between border-b border-b-[#e7e7e7] pb-4"
            onClick={() => {
              navigateTo("needHelp");
            }}
            aria-label="NEED HELP?"
          >
            NEED HELP?
            <CaretRight size={20} weight="light" />
          </button>
        </MenuItem>
      </>
    ),

    shipping: (
      <>
        <MenuItem>
          <button className="soft-button w-full gap-x-4 border-b border-b-[#e7e7e7] pb-4" onClick={navigateBack} aria-label="SHIPPING & ORDERS BACK">
            <CaretLeft size={20} weight="light" />
            SHIPPING & ORDERS
          </button>
        </MenuItem>
        <MenuItem>
          <a
            href="https://black-bough-swim.reamaze.com/kb/shipping"
            className="soft-button w-full border-b border-b-[#e7e7e7] pb-4"
            target="_blank"  
          >
            Shipping Policy
          </a>
          {/* <LinkButton
            className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
            to={`/`}
            label={'Shipping Policy'}
            ariaLabel="Shipping Policy"
          /> */}
        </MenuItem>
        {/* <MenuItem>
          <LinkButton
            className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
            to={`/`}
            label={'Shipping Rates'}
            ariaLabel="Shipping Rates"
          />
        </MenuItem> */}
      </>
    ),

    findYourFit: (
      <>
        <MenuItem>
          <button className="soft-button w-full gap-x-4 border-b border-b-[#e7e7e7] pb-4" onClick={navigateBack} aria-label="FIND YOUR FIT BACK">
            <CaretLeft size={20} weight="light" />
            FIND YOUR FIT
          </button>
        </MenuItem>
        <MenuItem>
          <LinkButton
            className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
            to={`/blackbough-size-guide/`}
            label={'General Size Guide'}
            aria-label="General Size Guide"
          />
        </MenuItem>
        <MenuItem>
          <LinkButton
            className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
            to={`/bikini-style-guide`}
            label={'Bikini Style Guide'}
            ariaLabel="Bikini Style Guide"
          />
        </MenuItem>
      </>
    ),

    returns: (
      <>
        <MenuItem>
          <button className="soft-button w-full gap-x-4 border-b border-b-[#e7e7e7] pb-4" onClick={navigateBack} aria-label="RETURNS & EXCHANGES BACK">
            <CaretLeft size={20} weight="light" />
            RETURNS & EXCHANGES
          </button>
        </MenuItem>
        {/* <MenuItem>
          <LinkButton
            className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
            to={`/request-a-return`}
            label={'Request A Return'}
            ariaLabel="Request A Return"
          />
        </MenuItem> */}
        <MenuItem>
          <a 
            className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
            href="https://black-bough-swim.reamaze.com/kb/returns"
            aria-label="Return Policy"
            target="_blank"
          >
              Return Policy
          </a>
          {/* <LinkButton
            className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
            to={`/`}
            label={'Return Policy'}
            ariaLabel="Return Policy"
          /> */}
        </MenuItem>
      </>
    ),

    needHelp: (
      <>
        <MenuItem>
          <button className="soft-button w-full gap-x-4 border-b border-b-[#e7e7e7] pb-4" onClick={navigateBack} aria-label="NEED HELP? BACK">
            <CaretLeft size={20} weight="light" />
            NEED HELP?
          </button>
        </MenuItem>
        <MenuItem>
          <LinkButton
            className={`soft-button w-full border-b border-b-[#e7e7e7] pb-4`}
            to={`/contact-us/`}
            label={'Contact Us'}
            ariaLabel="Contact Us"
          />
        </MenuItem>
      </>
    ),
  };

  return (
    <React.Fragment>
      {/* <div
        className="relative text-black flex items-center pr-2 lg:hidden cursor-pointer focus:outline-none"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <X size={24} /> : <List size={24} />}
      </div> */}

      {/* absolute left-0 w-56 mt-2 origin-top-left bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none */}

      <div className={`text-black flex pr-2 lg:hidden cursor-pointer focus:outline-none h-6 w-8 ${menuOpen && ''}`}>
        <Menu as="div" className={"relative"}>
          <MenuButton
            onClick={() => {
              setMenuOpen(!menuOpen);
              setMenuStack(["main"]);
            }}
            aria-label="Hamburger Menu"
          >
            {menuOpen ? <X size={24} /> : <List size={24} />}
          </MenuButton>

          {menuOpen && (
            <MenuItems
              transition
              anchor="bottom start"
              className={`mobile-nav-container !left-0 mt-4 z-[52]`}
              static={true}
            >
              {/* Search Bar */}
              {/* <div className="w-full mb-4">
                <SearchBar
                  id="navSearchBar"
                  onChange={(e) => handleSearchFieldChange(e)}
                  value={searchKeyword}
                />
              </div> */}

              {searchResults.length <= 0 && searchKeyword.trim() !== "" ? (
                <NoResultsFound />
              ) : (
                <>
                  {menus[currentMenu]}
                  {/* Shop All button at 1st level */}
                  {menuStack[menuStack.length - 1] === "main" && (
                    <div className="w-full self-end">
                      <LinkButton
                        to="/collections"
                        className={"btn-primary p-3 w-full justify-center"}
                        label={"SHOP ALL PRODUCTS"}
                        ariaLabel="SHOP ALL PRODUCTS"
                      />
                    </div>
                  )}
                </>
              )}

              {/* basic cards */}
              {menuStack[menuStack.length - 1] === "shop" && (
                <section className="w-full flex flex-wrap justify-between gap-y-4">
                  <BasicCard
                    data={{
                      label: "SHOP BEST SELLERS",
                      image: imgShopBestSellers,
                    }}
                    link={'/collections/bestsellers/'}
                    className='relative w-full lg:w-64 h-[220px] md:h-auto overflow-hidden cursor-pointer'
                    ariaLabel="SHOP BEST SELLERS"
                  />

                  <BasicCard
                    data={{
                      label: "SHOP NEW ARRIVALS",
                      image: imgNewArrivals,
                    }}
                    link={'/collections/new-arrivals/'}
                    className='relative w-full lg:w-64 h-[220px] md:h-auto overflow-hidden cursor-pointer'
                    ariaLabel="SHOP NEW ARRIVALS"
                  />
                </section>
              )}
            </MenuItems>
          )}
        </Menu>
        <div 
          className={`content-[''] fixed left-0 top-24 w-screen h-screen bg-black/25 z-0 ${!menuOpen && 'hidden'}`}
          onClick={() => {
            setMenuOpen(false)
            setMenuStack(["main"])
          }}
         /> 
      </div>
      <ScreenCover
        isOpen={menuOpen}
        onClick={() => setMenuOpen(false)}
        top="top-24"
      />
    </React.Fragment>
  );
}

export default NavBar